import { CheckCircle } from "lucide-react";

const AboutProgramme = ({ data }) => {
  const about = data.aboutSection;

  return (
    <section className="max-w-(--max-page-width) mx-auto px-(--container-padding) my-10 md:my-16 lg:my-24">
      <div className="w-full mx-auto grid lg:grid-cols-2 gap-12">
        <div>
          <span className="bg-[#FFA2011A]/90 text-[#FFA201] text-[13px] font-normal px-3 py-2 capitalize">
            {about.tag}
          </span>

          <h2 className="text-[20px] md:text-[25px] lg:text-[30px] xl:text-[42px] font-bold text-gray-900 mt-4 mb-6 leading-snug">
            {about.title}
          </h2>

          <div className="space-y-4 text-[#4B5563] text-base md:text-lg leading-relaxed">

            {about.description.map((para, i) => (
              <p key={i}>{para}</p>
            ))}

          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 mt-8">

            {about.stats.map((stat, i) => (

              <div
                key={i}
                className="bg-gray-100 p-4 rounded-md text-center"
              >
                <p
                  className={`font-bold text-lg md:text-2xl ${i === 1 ? "text-[#F47920]" : "text-[#0A2240]"
                    }`}
                >
                  {stat.value}
                </p>

                <p className="text-gray-600 text-[13px]">
                  {stat.label}
                </p>
              </div>

            ))}

          </div>

          <div className="flex flex-wrap gap-6 mt-6">
            {about.approvals.map((item, i) => (
              <div key={i} className="flex items-center gap-2 text-sm text-gray-600">
                <CheckCircle className="w-4 h-4 text-green-500" />
                {item}
              </div>
            ))}

          </div>

        </div>

        {/* RIGHT SIDE — JOURNEY */}
        <div className="bg-[#F5F7FA] p-8 rounded-lg">

          <h3 className="text-lg md:text-2xl font-semibold text-gray-900 mb-8">
            {about.journeyTitle}
          </h3>

          <div className="relative">
            <div className="absolute left-2 top-0 bottom-0 border-l-2 border-dashed border-[#FFA201]" />

            <div className="space-y-10">

              {about.journey.map((step, i) => (

                <div key={i} className="relative pl-8">

                  <div className="absolute left-0 top-0.3 w-4 h-4 bg-[#FFA201] rounded-full" />
                  <p className="text-[13px] text-[#FFA201] font-semibold">
                    {step.phase}
                  </p>
                  <h4 className="text-[19px] font-semibold text-[#0A2240] mt-1">
                    {step.title}
                  </h4>
                  <p className="text-base text-gray-600 mt-0.5">
                    {step.description}
                  </p>

                </div>

              ))}

            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default AboutProgramme;